import React, {useState, useEffect} from "react";
import { Navbar, Nav, NavItem, Grid, Row, Col, Alert } from "react-bootstrap";
import {connect} from "react-redux";
import {Link, Redirect, Route, Switch, withRouter} from "react-router-dom";
import {LinkContainer} from "react-router-bootstrap";
import {dismissMessage} from "../stores/messages/dismissMessage";
import CreateSigntask from "./CreateSigntask/CreateSigntask";
import {SignTaskList} from "./ListSigntasks/ListSigntasks";
import Signtask from "./Signtask/Signtask";
import { useIsAuthenticated, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import { useTranslation } from 'react-i18next';
import { Login } from "./Login";
import useToken from './useToken';

const flexContainer = {
    display: 'flex',
    alignItems: 'center'
}

const Navigation = (props) => { 
    const isAuthenticated = useIsAuthenticated();
    const { t } = useTranslation();
    
    return (
        <Navbar>
            <div style={flexContainer}>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to="/">{window.document.title}</Link>
                    </Navbar.Brand>
                </Navbar.Header>
                <Nav>
                    <LinkContainer to="/create-sign-task">
                        <NavItem>{t("create_signtask_nav_create")}</NavItem>
                    </LinkContainer>
                    <LinkContainer to="/list-sign-tasks">
                        <NavItem>{t("create_signtask_nav_list")}</NavItem>
                    </LinkContainer>
                </Nav>
                {props.useMsal ? (isAuthenticated ? <SignOutButton/> : <SignInButton/>) : ""}
            </div>
        </Navbar>);
};

const Content = withRouter(connect(
  state => ({
    messages: state.messages
  }),
  dispatch => ({
    dismiss: idx => () => dispatch(dismissMessage(idx))
  })
)(({messages, dismiss, initialSearchParams}) => (
  <Grid>
    <Row className="show-grid">
      <Col xs={12} md={12}>
        {messages.map((message, msgNr) => (
          <Alert key={msgNr} bsStyle={message.style} onDismiss={dismiss(msgNr)}>
            {message.lines.map((line, lineNr) => <span key={lineNr}>{line}<br /></span>)}
          </Alert>
        ))}
        <Switch>
          <Redirect exact from="/" to="/create-sign-task" />
          <Route exact path="/create-sign-task" component={CreateSigntask} />
          <Route exact path="/list-sign-tasks" render={(props) => <SignTaskList {...props} initialSearchParams={initialSearchParams} />} />
          <Route exact path="/sign-task/:id" component={Signtask} />
        </Switch>
      </Col>
    </Row>
  </Grid>
)));

export default () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(async () => {
    try{
      setLoading(true);
      let mounted = true;
      await fetch('/api/settings').then(res => res.json())
        .then(items => {
          if(mounted) {
            setSettings(items)
          }
        })
      return () => mounted = false;
    }
    finally{
      setLoading(false);
    }
    
  }, [])
    
  const { t } = useTranslation();
  const { token, setToken } = useToken();

  if(loading){ return (<div>...</div>); }

  if(!token && !settings.useMsal){
    return(<Login setToken={setToken} />);
  }
  
  let content = <Content initialSearchParams={settings.initialSearchParams} />
  if(settings.useMsal){
    content = <>
      <AuthenticatedTemplate>{content}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>{t("login_message")}</UnauthenticatedTemplate>
    </>
  }
  return(
    <div>
          <Navigation useMsal={settings.useMsal} />
          {content}
    </div>
  );
};
